import React from 'react';

interface TitleProps {
  title: string;
  className?: string;
}

function Title({ title, className }: TitleProps) {
  return (
    <>
      <h3
        className={`text-purple-300 font-semibold text-lg  uppercase my-2 ${className}`}
      >
        {title}
      </h3>
      <hr className="mb-3" />
    </>
  );
}

export default Title;
